import { config } from '@rematter/config';
import { enumLoadStatus } from '@rematter/frontend-lib-api-client';
import { maybe } from '@rematter/ui-web';

import { loadListQueryAtom } from '../_graphql/queryLoadList';
import { loadsCountingByStatusQueryAtom } from '../_graphql/queryLoadsCountingByStatus';

import { atomFromQueryString } from '~/shared/state';

type LoadStatusFilter = 'Shipped' | 'Received' | 'Reconciled';

// 🟣🟣🟣 PARAMS
export const $searchParam = atomFromQueryString.string('q');
export const $loadStatusFilter =
  atomFromQueryString.string<LoadStatusFilter>('status');

export const $limit = atomFromQueryString.number('limit', config.pageSize);
export const $offset = atomFromQueryString.number('offset', 0);

// 🟢🟢🟢 REMOTE DATA
export const $loadsCountingByStatus = loadsCountingByStatusQueryAtom();

// 🟢🟢🟢 REMOTE DATA
export const $remoteLoads = loadListQueryAtom((get) => {
  const statusFilter = get($loadStatusFilter);
  const searchParam = get($searchParam);

  return {
    variables: {
      searchTerm: searchParam,
      status: statusFilter
        ? [statusFilter]
        : [
            enumLoadStatus.Shipped,
            enumLoadStatus.Received,
            enumLoadStatus.Reconciled,
          ],
      pagination: maybe(get($limit), (limit) => ({
        limit,
        offset: get($offset),
      })),
    },
  };
});
